import React, { useRef, useEffect } from 'react'

export default function VideoSlide({ src, isActive, onEnded, onError }) {
  const videoRef = useRef(null)

  useEffect(() => {
    if (isActive && videoRef.current) {
      videoRef.current.play().catch(err => {
        console.error('Error playing video:', err)
        onError?.()
      })
    } else if (!isActive && videoRef.current) {
      videoRef.current.pause()
    }
  }, [isActive, onError])

  // Cleanup on unmount or when switching to another video
  useEffect(() => {
    return () => {
      if (videoRef.current) {
        videoRef.current.pause()
        videoRef.current.src = ''
        videoRef.current.load()
      }
    }
  }, [src])

  return (
    <div
      className={`media-slide video-slide ${isActive ? 'active' : ''}`}
      data-testid="video-slide">
      <video
        ref={videoRef}
        src={src}
        onEnded={onEnded}
        onError={onError}
        style={{
          width: '100%',
          height: '100vh',
          objectFit: 'cover',
          display: 'block',
        }}
      />
    </div>
  )
}
